import { Column } from '@components/UI-Components/HierarchyWiseItemsTable/models/column'
import shiftColumn from '@components/UI-Components/HierarchyWiseItemsTable/utils/shift-columns'
import { KPITableView } from '@modules/order/stores/view/KPI/EnhancedKPIViewTableService'
import { ListTableView } from '@modules/order/stores/view/List/ListViewTableService'
import { nav } from '@stores/nav'
import { isEmpty } from 'lodash'
import isNumber from 'lodash/isNumber'
import pickBy from 'lodash/pickBy'
import sortBy from 'lodash/sortBy'
import { action, observable } from 'mobx'

export const TABLE_SETTING_TYPE = {
  Rows: 'rows',
  Columns: 'columns',
  DoorKpiHeader: 'DoorsKPI-headers',
  DoorKpiSubHeader: 'DoorsKPI-subHeaders'
}

export const TABLE_SETTINGS_VIEWS = {
  Quantity: 'listViewQuantity',
  Summary: 'listViewSummary'
}

export class EnhancedTableSettingsStore {
  @observable enhancedTableSettings = null
  @observable settings = null
  @observable isTableSettingActive = false
  @observable tempSettingsData = {}

  @action setSettings = (settings: any) => {
    const {
      queryParams: { subSection }
    } = nav
    this.settings = settings

    if (subSection === KPITableView.DoorsKPI) {
      this.settings[TABLE_SETTING_TYPE.Columns] = {
        ...this.tempSettingsData,
        ...(settings[TABLE_SETTING_TYPE.Columns] || {})
      }
    }
  }

  @action setDoorsKpiSubHeadersSettings = columns => {
    columns?.forEach(option => {
      if (option.columns && option.columns.length) {
        this.tempSettingsData[option.field] = {}
        option.columns.forEach(column => {
          this.tempSettingsData[column.field] = {}
        })
      }
    })
  }

  @action
  setTableSettingsData = (columns: Column[], rows: any[], subSection: string, t: any) => {
    columns.map(
      column =>
        (column.label = column.key
          ? t(`order.listview.colHeader.${column.key}`, column.label)
          : column.label)
    )
    rows.map(
      row =>
        (row.label = row.key
          ? t(`order.otbHeaders.label.${row.key}`, row.label)
          : row.label)
    )
    const clusterColumns = columns?.filter(column => column.columns)

    let clusters = []
    if (subSection === KPITableView.DoorsKPI) {
      this.setDoorsKpiSubHeadersSettings(clusterColumns)
      const subHeaders = clusterColumns[0]
      clusters = [
        {
          id: TABLE_SETTING_TYPE.Columns,
          type: TABLE_SETTING_TYPE.DoorKpiSubHeader,
          label: t('common.label.subHeaders', 'Sub-Headers'),
          options: subHeaders?.columns
        }
      ]
    } else {
      clusters = clusterColumns?.map(cluster => {
        const { columns, label, field } = cluster
        return {
          id: field,
          label,
          options: columns
        }
      })
    }

    const enhancedTableSettings =
      subSection === KPITableView.DoorsKPI
        ? [
            {
              id: TABLE_SETTING_TYPE.Columns,
              type: TABLE_SETTING_TYPE.DoorKpiHeader,
              label: t('common.label.headers', 'Headers'),
              options: columns
            },
            ...clusters
          ]
        : [
            {
              id: TABLE_SETTING_TYPE.Columns,
              label: t(`common.label.${TABLE_SETTING_TYPE.Columns}`, 'Columns'),
              options: columns?.filter(column => !column.columns)
            },
            ...(subSection === ListTableView.Quantity && rows?.length
              ? [
                  {
                    id: TABLE_SETTING_TYPE.Rows,
                    label: t('common.label.kpiRows', 'KPI Rows'),
                    options: rows
                  }
                ]
              : []),
            ...clusters
          ]
    this.enhancedTableSettings = enhancedTableSettings
  }

  @action
  toggleTableSettingModal = (...args) => {
    if (args?.length) {
      this.isTableSettingActive = args[0]
    } else {
      this.isTableSettingActive = !this.isTableSettingActive
    }
  }

  @action sortedColumns(options, settings) {
    if (isEmpty(settings?.columns)) {
      return options
    }
    const columnsWithPosition = pickBy(settings?.columns, val => isNumber(val.position))

    if (isEmpty(columnsWithPosition)) {
      return options
    }
    return sortBy(
      Object.keys(columnsWithPosition).map(field => ({
        field,
        position: columnsWithPosition[field].position
      })),
      'position'
    ).reduce(
      (acc, { field, position }) => shiftColumn(acc, field, position),
      [...options]
    )
  }

  resetTableSettings = () => {
    this.enhancedTableSettings = null
    this.settings = null
  }
}
